import { getMarketingHomeHref } from "@/config/marketingHome";
import { Link } from "react-router-dom";

export default function AccountPending() {
  return (
    <section className="log-reg account-pending-view">
      <div className="account-pending-overlay">
        <div className="container">
          <div className="top-head-area account-pending-top">
            <a href={getMarketingHomeHref()} className="back-home">
              <i className="icon-arrow-left" />
              Back to Paylio
            </a>
          </div>
          <main className="account-pending-main">
            <article className="account-pending-card">
              <p className="account-pending-kicker">Almost there</p>
              <h4 className="account-pending-title">Account pending review</h4>
              <p className="account-pending-lead">
                Your account was created successfully. We are validating your profile details
                and will notify you once your dashboard is fully activated.
              </p>

              <ol className="account-pending-steps">
                <li>
                  <span className="account-pending-step-num">1</span>
                  <span>Check your email for verification and security updates.</span>
                </li>
                <li>
                  <span className="account-pending-step-num">2</span>
                  <span>Complete any remaining identity checks if requested.</span>
                </li>
                <li>
                  <span className="account-pending-step-num">3</span>
                  <span>Sign in again after approval to access your workspace.</span>
                </li>
              </ol>

              <p className="account-pending-note">
                Most reviews are completed within one business day.
              </p>
              <div className="account-pending-actions">
                <Link className="cmn-btn account-pending-btn-primary" to="/login">
                  Go to sign in
                </Link>
                <a
                  className="account-pending-btn-secondary"
                  href={getMarketingHomeHref()}>
                  Visit homepage
                </a>
              </div>
            </article>
          </main>
        </div>
      </div>
    </section>
  );
}
